import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {confirmerPaiementSouscriptionSaga} from "./confirmerPaiementSouscriptionSaga";

export default function* confirmerPaiementSouscriptionWatcher() {
  yield takeLatest(
    ActionsTypes.CONFIRMER_PAIEMENT_SOUSCRIPTION,
    confirmerPaiementSouscriptionSaga
  );
}
